import { Flex, ToastProvider } from '@vimeo/bokeh';
import { CommentsContainer, useGetCommentsCount } from '@vimeo/comments-view';
import { translate } from '@vimeo/i18n-runtime';
import { ModuleHeader } from '@vimeo/viewer-showcase-ui/components/ModuleHeader';
import { SearchIconButton } from '@vimeo/viewer-showcase-ui/modules';

import { LayoutToggle } from '../components/LayoutToggle';
import { useCommentsModule } from '../hooks/use-comments-module';
import { useAlbumStore } from '../state/albumStore';
import { COMMENTS_ANALYTICS_PROPS, CommentsModuleProps } from '../utils/types';

export const CommentsModule = ({
  clipOwnerUri,
  clipRequestId,
  clipId,
  privacyView,
  ...rest
}: CommentsModuleProps) => {
  const showcaseId = useAlbumStore((state) => state.albumId);

  const {
    onCloseSearch,
    onSearchClick,
    searchCommentQuery,
    searchInputRef,
    showCommentSearchBar,
    updateCommentSearchQuery,
  } = useCommentsModule({
    clipRequestId,
    clipId,
    privacyView,
    ...rest,
  });
  const { commentsCount } = useGetCommentsCount(clipRequestId, true, undefined, showcaseId);

  return (
    <ToastProvider>
      <Flex direction="column" w="100%" h="100%" data-testid="comments-module">
        <ModuleHeader
          text={translate('Comments')}
          count={commentsCount}
          showCommentSearchBar={showCommentSearchBar}
          updateCommentSearchQuery={updateCommentSearchQuery}
          onCloseSearch={onCloseSearch}
          searchInputRef={searchInputRef}
        >
          <SearchIconButton onClick={onSearchClick} />
          <LayoutToggle clipId={clipId} clipOwnerUri={clipOwnerUri} privacyView={privacyView} />
        </ModuleHeader>
        <CommentsContainer
          clipRequestId={clipRequestId}
          clipId={clipId}
          isPublic
          searchQuery={searchCommentQuery}
          analyticsProps={COMMENTS_ANALYTICS_PROPS}
          onMomentPlay={() => undefined}
          showcaseId={showcaseId}
        />
      </Flex>
    </ToastProvider>
  );
};
